import { MessageSubType } from '@smartsupp/smartsupp-message'
import { type BotIdentity, ChatStatus } from '@smartsupp/websocket-client-visitor'
import { derived, type Readable } from 'svelte/store'

import { chatStatus } from '../chat'
import { sortedMessages } from '../messages'
import { botIdentities } from './store'

export const messageWithBotIdentity: Readable<BotIdentity | null> = derived(
	[sortedMessages, botIdentities, chatStatus],
	([$sortedMessages, $botIdentities, $chatStatus], set: (value: BotIdentity | null) => void) => {
		const lastMessage = [...$sortedMessages].reverse().find((m) => m.subType !== MessageSubType.System)
		const identityId = lastMessage?.trigger?.identityId
		if ($chatStatus !== ChatStatus.Served && lastMessage?.subType === MessageSubType.Bot && identityId) {
			set($botIdentities[identityId] ?? null)
		} else {
			set(null)
		}
	},
)

export const getIdentityById = (botIdentity: string) =>
	derived([botIdentities], ([$botIdentities]): BotIdentity | null => {
		return $botIdentities[botIdentity] ?? null
	})
